export const SELECTORS = [
	'selectorName',
	'selectorManufacturer',
	'selectorPrice',
	'selectorCurrency',
	'selectorArticleNumberOne',
	'selectorArticleNumberTwo',
	'selectorArticleNumberThree',
	'selectorImgUrl',
	'selectorStockStatus',
	'selectorDeliveryTime',
	'selectorDescription',
	'selectorFullDescription',
	'selectorActiveIngredients',
	'selectorOtherIngredients',
	'selectorAllIngredients',
	'selectorBrand',
	'selectorRatingValue',
	'selectorRatingCount',
	'selectorAmount1',
	'selectorUnit1',
	'selectorAmountUnit1',
	'selectorAmount2',
	'selectorUnit2',
	'selectorAmountUnit2',
	'selectorCategory',
	'selectorBreadcrumbs'
] as const;

export const EXPECTED_VALUES = [
	'expectedName',
	'expectedManufacturer',
	'expectedPrice',
	'expectedCurrency',
	'expectedArticleNumberOne',
	'expectedArticleNumberTwo',
	'expectedArticleNumberThree',
	'expectedImgUrl',
	'expectedStockStatus',
	'expectedDeliveryTime',
	'expectedDescription',
	'expectedFullDescription',
	'expectedActiveIngredients',
	'expectedOtherIngredients',
	'expectedAllIngredients',
	'expectedBrand',
	'expectedRatingValue',
	'expectedRatingCount',
	'expectedAmount1',
	'expectedUnit1',
	'expectedAmountUnit1',
	'expectedAmount2',
	'expectedUnit2',
	'expectedAmountUnit2',
	'expectedCategory',
	'expectedBreadcrumbs'
] as const;

export const ACTUAL_VALUES = [
	'actualName',
	'actualManufacturer',
	'actualPrice',
	'actualCurrency',
	'actualArticleNumberOne',
	'actualArticleNumberTwo',
	'actualArticleNumberThree',
	'actualImgUrl',
	'actualStockStatus',
	'actualDeliveryTime',
	'actualDescription',
	'actualFullDescription',
	'actualActiveIngredients',
	'actualOtherIngredients',
	'actualAllIngredients',
	'actualBrand',
	'actualRatingValue',
	'actualRatingCount',
	'actualAmount1',
	'actualUnit1',
	'actualAmountUnit1',
	'actualAmount2',
	'actualUnit2',
	'actualAmountUnit2',
	'actualCategory',
	'actualBreadcrumbs'
] as const;

export function toDisplayName(valueName: string): string {
	let output = valueName;
	if (valueName.startsWith('selector')) {
		output = valueName.slice('selector'.length);
	} else if (valueName.startsWith('expected')) {
		output = valueName.slice('expected'.length);
	} else if (valueName.startsWith('actual')) {
		output = valueName.slice('actual'.length);
	}
	return output;
}
